(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/collections/draws.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/collections/draws.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.collections.Draws = Backbone.Collection.extend({
    model: svs.tipset.models.Draw,
    log: new svs.core.log.Logger('svs.tipset.collections.Draws'),

    initialize: function() {
      var hasDraws = svs.utils.ns.isNamespace('svs.tipset.data.draws');

      if (hasDraws) {
        this.set(svs.tipset.data.draws);
        this.setCurrentDraw(svs.tipset.data.params.did);
      }
    },

    getDrawById: function(drawNumber) {
      return _.find(this.models, function(draw) {
        return draw.get('drawNumber') == drawNumber;
      });
    },

    getAllDraws: function() {
      return this.models;
    },

    setJackpot: function(jackpotData) {
      this.at(0).setJackpotData(jackpotData);
    },

    getCurrentDraw: function() {
      return _.find(this.models, function(draw) {
        return draw.get('isCurrentDraw');
      });
    },

    setCurrentDraw: function(drawNumber) {
      var currentDrawNr =
        drawNumber && drawNumber.split('_').length > 1
          ? drawNumber.split('_')[1]
          : drawNumber,
        productId =
          drawNumber && drawNumber.split('_').length > 1
            ? parseInt(drawNumber.split('_')[0], 10)
            : undefined;

      this.each(function(draw) {
        if (productId) {
          if (
            draw.get('drawNumber') == currentDrawNr &&
            draw.get('productId') == productId
          ) {
            draw.set('isCurrentDraw', true);
          } else {
            draw.set('isCurrentDraw', false);
          }
        } else {
          if (draw.get('drawNumber') == currentDrawNr) {
            draw.set('isCurrentDraw', true);
          } else {
            draw.set('isCurrentDraw', false);
          }
        }
      });
    },

    getFirstDraw: function() {
      return this.at(0);
    },

    isCurrentDrawOpen: function() {
      return this.getCurrentDraw().getIsOpen();
    }
  });
})(Backbone, _, svs);

 })(window);